module.exports = __webpack_public_path__ + "static/media/CBNImg7.38fa4e7f.webp";